const RECENTLY_VIEWED_PRODUCTS_KEY = "im_recently_viewed_products";
const RECENTLY_VIEWED_LIMIT = 10;

const getProductImage = (product) => {
  if (product?.mainImage?.[0]?.imageurl) return product.mainImage[0].imageurl;
  if (product?.image?.[0]?.imageurl) return product.image[0].imageurl;
  if (typeof product?.image === "string") return product.image;
  return "";
};

export const getRecentlyViewedProducts = () => {
  if (typeof window === "undefined") return [];

  try {
    const rawProducts = window.localStorage.getItem(RECENTLY_VIEWED_PRODUCTS_KEY);
    const products = rawProducts ? JSON.parse(rawProducts) : [];
    return Array.isArray(products) ? products : [];
  } catch (error) {
    return [];
  }
};

export const saveRecentlyViewedProduct = (product) => {
  if (typeof window === "undefined" || !product?._id) return [];

  const viewedProduct = {
    _id: product._id,
    name: product.name,
    price: product.discountActive ? product.price - product.discountPrice : product.price,
    originalPrice: product.price,
    tag: product.tag,
    brandName: product.brandName,
    ratings: product.ratings || 0,
    image: getProductImage(product),
    viewedAt: Date.now(),
  };

  const products = getRecentlyViewedProducts();
  const nextProducts = [
    viewedProduct,
    ...products.filter((item) => item._id !== product._id),
  ].slice(0, RECENTLY_VIEWED_LIMIT);

  window.localStorage.setItem(
    RECENTLY_VIEWED_PRODUCTS_KEY,
    JSON.stringify(nextProducts)
  );

  window.dispatchEvent(new Event("recentlyViewedProductsUpdated"));
  return nextProducts;
};
